// NO GREEN for score labels — scarcity-first framing
export const getScoreColor = (s) => s >= 65 ? "text-[#F59E0B]" : s >= 40 ? "text-[#D97706]" : "text-[#DC2626]";
export const getScoreBg = (s) => s >= 65 ? "bg-[#F59E0B]" : s >= 40 ? "bg-[#D97706]" : "bg-[#DC2626]";
export const getScoreLabel = (s) => {
  if (s >= 85) return "FALSE SAFETY ZONE";
  if (s >= 65) return "RANKING RISK";
  if (s >= 40) return "LOSING GROUND";
  return "CRITICAL ISSUES";
};
export const getScoreInterpretation = (s) => {
  if (s >= 85) return "Your profile is maintained — but you're NOT ranking where you should be.";
  if (s >= 65) return "Visible but vulnerable. Competitors are catching up.";
  if (s >= 40) return "Your competitors are actively taking your customers.";
  return "Serious ranking problems. Every day without fixes costs you customers.";
};

// Signal bar colors (green only on bars, never labels)
export const getSignalBarColor = (s) => {
  if (s >= 85) return "bg-[#059669]";
  if (s >= 65) return "bg-[#F59E0B]";
  if (s >= 40) return "bg-[#D97706]";
  return "bg-[#DC2626]";
};

export const impactColor = (level) => {
  if (level === "high") return "bg-red-50 text-red-500 border-red-200";
  if (level === "medium") return "bg-amber-50 text-amber-500 border-amber-200";
  return "bg-emerald-50 text-emerald-500 border-emerald-200";
};

export const diffBadge = (d) => {
  if (d === "easy") return "bg-emerald-50 text-emerald-500 border-emerald-200";
  if (d === "medium") return "bg-amber-50 text-amber-500 border-amber-200";
  return "bg-red-50 text-red-500 border-red-200";
};

export const winBadge = (t) => t === "quick_win" ? "bg-blue-50 text-blue-500 border-blue-200" : "bg-purple-500/10 text-purple-500 border-purple-500/20";
